import { render, staticRenderFns } from "./override-customizations.vue?vue&type=template&id=554fcc4d"
import script from "./override-customizations.vue?vue&type=script&lang=js"
export * from "./override-customizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports